import './../../scss/theme/components/news.scss';

window.addEventListener('DOMContentLoaded', () => {

  const swiper = new Swiper('.news_swiper', {
    loop: true,
    spaceBetween: 24,
    autoHeight: true,
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      740: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      1400: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  });

});



